import React from 'react'
import Table from '../components/Table/Table'
import Navbar from '../components/Navbar/Navbar'

function TablePage() {
  return (
    <>
    <Navbar/>
    <Table/>
    </>
  )
}

export default TablePage
